import Vue from 'vue';
import VueResource from 'vue-resource';
import Router from 'vue-router';
import Store from '@/store.js';
import { BASE_URL } from "@/helpers/Constants";

Vue.use(Router);
Vue.use(VueResource);

export default {
  processRequest(url = '', method = 'get', data = {}) {
    Store.commit("addRequest");
    Store.commit('showLoader', true);

    url = BASE_URL + url;

    if (url !== '/MediaLibrary' && method !== 'post') {
      data = JSON.stringify(data);
    }

    Vue.http.interceptors.push((request, next) => {
      request.headers.set("Authorization", localStorage.token);
      next();
    });

    return Vue.http[method](
      url,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(response => {
        Store.commit("removeRequest");
        if (Store.state.activeRequests === 0) {
          Store.commit("showLoader", false);
        }
        return response;
      },
      response => {
        Store.commit("removeRequest");
        if (Store.state.activeRequests === 0) {
          Store.commit("showLoader", false);
        }
        if (response && response.statusText && response.statusText === "Unauthorized") {
          localStorage.removeItem('token');
          window.location.href = "/#/";
        }
        if (response && response.body && response.body.message && response.body.message === "Not Authenticated") {
          localStorage.removeItem('token');
          window.location.href = "/#/";
        } else if (response && response.body && response.body.message && response.body.message === "access denied") {
          window.location.href = "/#/published";
          alert('You haven\'t access to this route. Please connect to site admin!');
        } else {
          Store.commit('showLoader', false);
          return response;
        }
      });
  },
  getAllImages() {
    return Vue.http.get(this.prefix + `/MediaLibrary/GetImages/Image?mallId=${localStorage.mallId}`).then(
      response => {
        if (response.body && response.body.success) {
          alert(response.body.message);
        } else {
          return response.body;
        }
      },
      response => {
        console.log(response);
        alert("Error during request!");
      });
  },
  async postSlideshowContent(id, model) {
    // eslint-disable-next-line no-return-await
    return await Vue.http.post(this.prefix + `/Slideshow/${id}?mallId=${localStorage.mallId}`, model);
  },
  deleteSlideshow(id) {
    return Vue.http.delete(this.prefix + '/Slideshow?id=' + id);
  },
};
